export default class VisitorService {
  constructor(private readonly cookiesService: Cookies.CookiesStatic) {}

  get cookieDomain(): string {
    const subdomainParts = window.location.hostname.split('.');

    if (subdomainParts.length > 2) {
      subdomainParts.shift();
    }

    return `.${subdomainParts.join('.')}`;
  }

  get visitorUUID(): string {
    const COOKIE_NAME = 'ks_visitor_id';

    const visitorUUID = this.cookiesService.get(COOKIE_NAME);

    if (visitorUUID) {
      return visitorUUID;
    }

    const newUdid =
      'randomUUID' in crypto
        ? crypto.randomUUID()
        : VisitorService.generateVisitorUUIDFallback();

    this.cookiesService.set(COOKIE_NAME, newUdid, {
      expires: 365,
      domain: this.cookieDomain,
    });

    return newUdid;
  }

  private static generateVisitorUUIDFallback(): string {
    const segment = (length: number) => {
      let result = '';

      while (result.length < length) {
        result += Math.random().toString(36).substring(2);
      }

      return result.substring(0, length);
    };

    return [segment(8), segment(4), segment(4), segment(4), segment(12)].join(
      '-',
    );
  }
}
